module.exports = __webpack_public_path__ + "static/media/Intersection 34.cfa20355.png";